import './styles/syncview.scss'

import React, { Component, Fragment } from 'react'

import ArrowIcon from './../assets/icons/arrow-up.svg'
import ArrowIconWaiting from './../assets/icons/arrow-up-waiting.svg'
import ArrowIconError from './../assets/icons/arrow-up-error.svg'
import CheckIcon from './../assets/icons/check.svg'
import BoxIcon from './../assets/icons/box-data.svg'
import BoxIconWaiting from './../assets/icons/box-data-waiting.svg'
import BoxIconError from './../assets/icons/box-data-error.svg'
import { Tooltip, CircularProgress } from '@mui/material'
import { connect } from 'react-redux'
import hasInternet from './../utils/recognizeInternetConnection'
import SyncProblemIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'
import RefreshIcon from '@mui/icons-material/Refresh'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import { changeSyncView } from '../redux/sync/actions'
import { SYNC_STATUS, SYNC_STATUS_LABELS } from '../redux/sync/constants'
import { tokens } from '../theme'

class SyncView extends Component {
  errorSync = () => (
    <button style={{ background: 'none', border: 'none' }}>
      <Tooltip title='Dados não enviados' arrow>
        <div style={{ display: 'grid' }} className='syncViewError'>
          <div style={{ position: 'absolute', top: '5px', left: '4px' }}>
            <img
              style={{ position: 'absolute' }}
              src={ArrowIconError}
              width='22'
            />
            {/* <SyncProblemIcon
              style={{ fontSize: '27px', position: 'absolutee', top: '5px', left: '43px' }}
            ></SyncProblemIcon> */}
            <SyncProblemIcon
              style={{
                fontSize: '24px',
                color: tokens.semantic.error.main,
                position: 'absolute',
                top: '5px',
                left: '26px',
              }}
            ></SyncProblemIcon>
            <img
              style={{ position: 'absolute' }}
              src={BoxIconError}
              width='22'
            />
          </div>
        </div>
      </Tooltip>
    </button>
  )

  // Envio aceito, mas há registros recusados pelo servidor: nada de ✓ verde (QA HML U3).
  attentionSync = () => (
    <button style={{ background: 'none', border: 'none' }}>
      <Tooltip
        title='Há registros recusados pelo servidor. Toque para ver.'
        arrow
      >
        <div
          style={{ display: 'grid' }}
          className='syncViewError'
          data-state='attention'
        >
          <div style={{ position: 'absolute', top: '5px', left: '4px' }}>
            <img
              style={{ position: 'absolute' }}
              src={ArrowIconWaiting}
              width='22'
            />
            <WarningIcon
              style={{
                fontSize: '24px',
                color: tokens.semantic.warning.main,
                position: 'absolute',
                top: '5px',
                left: '26px',
              }}
            />
            <img
              style={{ position: 'absolute' }}
              src={BoxIconWaiting}
              width='22'
            />
          </div>
        </div>
      </Tooltip>
    </button>
  )

  loadingSync = () => (
    <Tooltip title='Enviando dados...' arrow>
      <div style={{ display: 'grid' }} className='syncView'>
        <div style={{ position: 'absolute', top: '5px', left: '23px' }}>
          <img
            style={{ fill: 'green', position: 'absolute' }}
            className='syncViewPushIcon'
            src={ArrowIconWaiting}
            width='22'
          />
          <img
            style={{ position: 'absolute' }}
            src={BoxIconWaiting}
            width='22'
          />
        </div>
      </div>
    </Tooltip>
  )

  successSync = () => (
    <Tooltip title='Dados enviados' arrow>
      <div style={{ display: 'grid' }} className='syncViewSuccess'>
        <div style={{ position: 'absolute', top: '5px', left: '4px' }}>
          <img style={{ position: 'absolute' }} src={ArrowIcon} width='22' />
          <img
            style={{ position: 'absolute', top: '5px', left: '28px' }}
            src={CheckIcon}
            width='22'
          />
          <img style={{ position: 'absolute' }} src={BoxIcon} width='22' />
        </div>
      </div>
    </Tooltip>
  )

  // Novos estados detalhados para fazendas grandes

  downloadingFarmSync = () => {
    const { progress } = this.props
    const tooltipText =
      progress?.attempt > 0
        ? `Baixando dados... (tentativa ${progress.attempt}/${progress.maxAttempts || 3})`
        : 'Baixando dados da fazenda...'

    return (
      <Tooltip title={tooltipText} arrow>
        <div
          style={{ display: 'grid' }}
          className='syncView syncViewDownloading'
        >
          <div style={{ position: 'absolute', top: '5px', left: '5px' }}>
            <CloudDownloadIcon
              style={{
                fontSize: '22px',
                color: tokens.semantic.info.main,
                animation: 'pulse 1.5s ease-in-out infinite',
              }}
            />
            <CircularProgress
              size={18}
              thickness={4}
              style={{
                position: 'absolute',
                top: '8px',
                left: '28px',
                color: tokens.semantic.info.main,
              }}
            />
          </div>
        </div>
      </Tooltip>
    )
  }

  processingSync = () => (
    <Tooltip title='Processando registros...' arrow>
      <div style={{ display: 'grid' }} className='syncView'>
        <div style={{ position: 'absolute', top: '5px', left: '23px' }}>
          <img
            style={{ fill: 'green', position: 'absolute' }}
            className='syncViewPushIcon'
            src={ArrowIconWaiting}
            width='22'
          />
          <CircularProgress
            size={18}
            thickness={5}
            style={{
              position: 'absolute',
              top: '-2px',
              left: '6px',
              color: tokens.semantic.success.main,
            }}
          />
          <img
            style={{ position: 'absolute' }}
            src={BoxIconWaiting}
            width='22'
          />
        </div>
      </div>
    </Tooltip>
  )

  retryingSync = () => {
    const { progress } = this.props
    const tooltipText =
      progress?.attempt > 0
        ? `Tentando novamente... (${progress.attempt}/${progress.maxAttempts || 3})`
        : 'Erro - tentando novamente...'

    return (
      <Tooltip title={tooltipText} arrow>
        <div style={{ display: 'grid' }} className='syncViewRetrying'>
          <div style={{ position: 'absolute', top: '5px', left: '4px' }}>
            <RefreshIcon
              style={{
                fontSize: '22px',
                color: tokens.semantic.warning.main,
                animation: 'spin 1s linear infinite',
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '4px',
                left: '28px',
                fontSize: '11px',
                fontWeight: 'bold',
                color: tokens.semantic.warning.main,
              }}
            >
              {progress?.attempt || '?'}/{progress?.maxAttempts || 3}
            </span>
          </div>
        </div>
      </Tooltip>
    )
  }

  getCurrentSyncStatus() {
    const { currentSync } = this.props

    // Verificar conexão primeiro
    if (!hasInternet()) {
      return this.errorSync()
    }

    // Mapear status para componentes
    switch (currentSync) {
      case SYNC_STATUS.ERROR:
        return this.errorSync()

      case SYNC_STATUS.SYNCING:
        return this.loadingSync()

      case SYNC_STATUS.SUCCESS:
        return this.props.tone === 'refused'
          ? this.attentionSync()
          : this.successSync()

      case SYNC_STATUS.DOWNLOADING_FARM:
        return this.downloadingFarmSync()

      case SYNC_STATUS.PROCESSING:
        return this.processingSync()

      case SYNC_STATUS.RETRYING:
        return this.retryingSync()

      default:
        // Fallback para comportamento legado
        if (currentSync == 0) return this.errorSync()
        if (currentSync == 1) return this.loadingSync()
        if (currentSync == 2) {
          return this.props.tone === 'refused'
            ? this.attentionSync()
            : this.successSync()
        }
        return this.loadingSync()
    }
  }

  render() {
    return (
      <Fragment>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {this.getCurrentSyncStatus()}
        </div>
      </Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeSyncView: (payload) => dispatch(changeSyncView(payload)),
  }
}

const mapStateToProps = (state) => ({
  currentSync: state.sync.currentSync,
  progress: state.sync.progress,
})

export default connect(mapStateToProps, mapDispatchToProps)(SyncView)
